export const FISCAL_YEAR = "FISCAL_YEAR";
export const ACTIVITY_TYPES = [
  { value: "Volunteer Phonecall", label: "Phone", icon: "call", iconColor: "#71C19E" },
  { value: "Volunteer Email", label: "Email", icon: "email", iconColor: "#F5A623" },
  {
    value: "Volunteer Text Message",
    label: "Text",
    icon: "textsms",
    iconColor: "#4A90E2",
  },
  {
    value: "Volunteer Social",
    label: "Social",
    icon: "social",
    iconColor: "#EA6272",
  },
  { value: "Volunteer Note", label: "Note", icon: "note-add", iconColor: "#757575" },
  { value: "Volunteer Virtual Visit", label: "Virtual Visit", icon: "desktop-mac", iconColor: "#f5a623" },
];
